module.exports = __webpack_public_path__ + "img/CW.c2c720ba.svg";